export default __webpack_public_path__ + "static/media/1654.1fc580fd.png";